var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFrontPageTutorial3 = function SvgIconFrontPageTutorial3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.584 5.834c8.052 0 14.583 6.528 14.583 14.588S27.637 35 19.584 35 5 28.471 5 20.422c0-8.05 6.522-14.588 14.584-14.588M15.643 26.43c0 .283.302.463.548.32l10.415-6.008a.372.372 0 0 0 0-.643L16.2 14.091a.366.366 0 0 0-.548.322V26.43z"
  })));
};
export default SvgIconFrontPageTutorial3;